import { z } from "zod"

export const PurchasedSupplySchema = z.object({
	daysSupply: z.number().int().positive(),
	refillAllowance: z.number({
		error: (issue) => issue.code === "invalid_type" && issue.expected === "number"
			? "Enter the number of refills after initial supply."
			: undefined,
	}).int().nonnegative(),
	isRecurringMembership: z.boolean(),
	renewalCadenceDays: z.number().int().positive().nullable(),
	paymentLeadDays: z.number().int().nonnegative().nullable(),
	reminderLeadDays: z.number().int().nonnegative().nullable(),
}).superRefine((value, context) => {
	if (!value.isRecurringMembership && value.refillAllowance > 0) {
		context.addIssue({ code: "custom", path: ["refillAllowance"], message: "Later paid refills require recurring billing." })
	}
	if (value.isRecurringMembership) {
		for (const field of ["renewalCadenceDays", "paymentLeadDays", "reminderLeadDays"] as const) {
			if (value[field] === null) context.addIssue({ code: "custom", path: [field], message: "Recurring billing requires an explicit schedule." })
		}
		if (value.renewalCadenceDays !== null && value.paymentLeadDays !== null && value.reminderLeadDays !== null && value.paymentLeadDays + value.reminderLeadDays >= value.renewalCadenceDays) {
			context.addIssue({ code: "custom", path: ["paymentLeadDays"], message: "Payment and reminder leads must fit inside the cycle." })
		}
	}
})

export type PurchasedSupply = z.infer<typeof PurchasedSupplySchema>
